export default "__VITE_ASSET__68ef0a40__"